namespace $.$$ {

	$mol_style_define( $shm_hitalama_process_monitor, {

		maxWidth: '100%',
		overflow: 'hidden',

		Page: {
			width: 'stretch' as any,
			flex: {
				shrink: 1,
				grow: 1,
			},
		},

		Menu: {
			flex: {
				basis: '36rem',
			},

			Body_content: {
				gap: '0.5rem',
			},
		},

		Menu_filter: {
			width: 'stretch' as any,
		},

		Menu_links: {
			width: 'auto',
			maxWidth: 'none',
		},

		Menu_tools: {
			display: 'flex',
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
		},

		Menu_item: {
			minWidth: '0px',
			align: {
				items: 'center',
			},
			gap: 0,
			flex: {
				grow: 1,
				wrap: 'nowrap',
				shrink: 1,
			},
			overflow: 'hidden',
			border: {
				radius: $mol_gap.round,
			},
			'@': {
				shm_hitalama_process_monitor_current: {
					true: {
						background: {
							color: $mol_theme.card,
						},
					},
				},
			},
		},

		Menu_detail: {
			padding: { top: 0, right: 0, bottom: 0, left: $mol_gap.block },
			minWidth: 0,
			minHeight: 0,
			height: 'stretch' as any,
			flex: {
				shrink: 0,
			},
		},

		Menu_widget: {
			padding: { top: 0, right: 0, bottom: 0 },
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
			flex: {
				grow: 1,
				shrink: 1,
				wrap: 'nowrap',
			},
			overflow: 'hidden',
			justify: {
				content: 'flex-start',
			},
		},

		Exclude_filter: {
			flex: {
				shrink: 0,
			},
		},

		Exclude_label: {
			padding: {
				bottom: $mol_gap.text,
			},
			font: {
				weight: 600,
			},
		},

		Exclude_input: {
			width: '100%',
		},

		Process_duration: {
			transition: 'none',
			padding: 0,
			whiteSpace: 'nowrap',
			textAlign: 'right',
			height: 'stretch' as any,
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
			},
			flex: {
				shrink: 0,
			},
			justify: {
				content: 'flex-end'
			},
			align: {
				items: 'center',
			},
		},

		Menu_link_status: {
			padding: {
				top: '.15rem',
				bottom: '.15rem',
				left: '.45rem',
				right: '.45rem',
			},
			border: {
				radius: $mol_gap.round,
			},
			background: {
				color: $mol_theme.line,
			},
			font: {
				size: '.75rem',
				weight: 600,
			},
			textTransform: 'uppercase',
			flex: {
				shrink: 0,
			},
		},

		Menu_link_title: {
			width: '100%',
			minWidth: 0,
			flex: {
				grow: 1,
				shrink: 1,
			},
			overflow: 'hidden',
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'normal',
		},

	} )

}
